import { Flex, Text } from "@mantine/core";
import Link from "next/link";
import { memo } from "react";
import { HighlightTextWrapperMemo } from "src/component/element";
import { AvatarIconMemo } from "src/component/element/AvatarIcon/AvatarIcon";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

import styles from "./AvatarIconAndNameLink.module.scss";

const AvatarIconAndNameLink = ({
  userId,
  profileImage,
  profileBgImage,
  nickname,
}: {
  userId: string;
  profileImage?: string | null;
  profileBgImage?: string | null;
  nickname: string;
}) => {
  const { data: currentUser } = useGetUserSettingsQuery();

  return (
    <Link
      className={styles.link}
      href={currentUser?.id === userId ? "/mypage" : `/other/${userId}`}
      passHref
      aria-label="ユーザーページへ遷移"
    >
      <Flex align="center" gap={12} sx={{ width: "fit-content" }}>
        <AvatarIconMemo avatar={profileImage} background={profileBgImage} />
        <Text fw={"bold"}>
          <HighlightTextWrapperMemo text={nickname} />
        </Text>
      </Flex>
    </Link>
  );
};

export const AvatarIconAndNameLinkMemo = memo(AvatarIconAndNameLink);
